<div class="user-guide-container">
  <button class="sidebar-toggle" id="sidebar-toggle" aria-label="Toggle menu" aria-controls="sidebar"
    aria-expanded="true">&#9776;</button>
  <nav class="sidebar" id="sidebar" aria-label="Main menu">
    <div class="sidebar-slide" id="sidebar-slide">
      <div class="sidebar-header">
        <span class="sidebar-title">XPeer.AI</span>
      </div>
      <div class="search-container">
        <div class="search-input-wrap">
          <span class="search-icon" aria-hidden="true"><mat-icon>search</mat-icon></span>
          <input id="guide-search" class="guide-search-input" type="text" placeholder="Search guides..."
            aria-label="Search guides" autocomplete="off" />
          <button id="guide-search-clear" class="search-clear" aria-label="Clear search" hidden>&times;</button>
        </div>
        <div id="guide-search-results" class="guide-search-results" role="listbox" aria-label="Search results" hidden>
        </div>
      </div>
      <h2>Introduction</h2>
      <ul class="menu">
        <li class="menu-item active" data-content="what-is" tabindex="0" role="menuitem" aria-current="page">
          What is XPeer.AI?</li>
        <li class="menu-item" data-content="installation" tabindex="0" role="menuitem">Installation</li>
        <li class="menu-item expandable" data-toggle="essentials" tabindex="0" role="menuitem" aria-haspopup="true"
          aria-expanded="false">
          Essentials <span class="expand-toggle" aria-hidden="true">&#9654;</span>
          <ul class="submenu" id="essentials" role="menu">
            <li class="menu-item" data-content="getting-started" tabindex="0" role="menuitem">Getting
              Started</li>
            <li class="menu-item" data-content="best-practices" tabindex="0" role="menuitem">Best Practices
            </li>
          </ul>
        </li>
      </ul>
      <h2>In-depth Guides</h2>
      <ul class="menu">
        <li class="menu-item expandable" data-toggle="guides" tabindex="0" role="menuitem" aria-haspopup="true"
          aria-expanded="false">
          Action Reference <span class="expand-toggle" aria-hidden="true">&#9654;</span>
          <ul class="submenu" id="guides" role="menu">
            <li class="menu-item has-child" id="browser-nav-parent" tabindex="0" role="menuitem">Browser
            </li>
            <li class="menu-item" data-content="user-interaction" tabindex="0" role="menuitem">Interaction
            </li>
            <li class="menu-item" data-content="math-variable" tabindex="0" role="menuitem">Math &amp; Vars
            </li>
            <li class="menu-item" data-content="logic-flow" tabindex="0" role="menuitem">Logic</li>
            <li class="menu-item" data-content="assertion-verification" tabindex="0" role="menuitem">Verify
            </li>
            <li class="menu-item" data-content="element-retrieval" tabindex="0" role="menuitem">Get Data
            </li>
            <li class="menu-item" data-content="alert-popup" tabindex="0" role="menuitem">Alerts</li>
            <li class="menu-item" data-content="dropdown-selection" tabindex="0" role="menuitem">Dropdown
            </li>
            <li class="menu-item" data-content="utility-actions" tabindex="0" role="menuitem">Utility</li>
            <li class="menu-item" data-content="api-actions" tabindex="0" role="menuitem">API</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="sidebar-child-panel" id="sidebar-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="sidebar-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title" id="sidebar-child-title">Browser Navigation</span>
      </div>
      <ul class="menu" id="browser-nav-child-menu">

        <!-- Navigation & Window Handling -->
        <li class="menu-heading">Window Handling</li>

        <li class="menu-item" data-content="open-url" tabindex="0" role="menuitem">Open URL</li>
        <li class="menu-item" data-content="get-current-url" tabindex="0" role="menuitem">Get Current URL</li>

        <li class="menu-item" data-content="open-new-tab" tabindex="0" role="menuitem">Open New Tab</li>
        <li class="menu-item" data-content="open-new-window" tabindex="0" role="menuitem">Open New Window</li>

        <li class="menu-item" data-content="close-window" tabindex="0" role="menuitem">Close Window</li>
        <li class="menu-item" data-content="close-current-window" tabindex="0" role="menuitem">Close Current Window</li>
        <li class="menu-item" data-content="close-all-except-original-window" tabindex="0" role="menuitem">
          Close All Except Original Window
        </li>

        <li class="menu-item" data-content="switch-to-main-window" tabindex="0" role="menuitem">Switch to Main Window
        </li>
        <li class="menu-item" data-content="switch-to-original-window" tabindex="0" role="menuitem">
          Switch to Original Window
        </li>
        <li class="menu-item" data-content="switch-to-new-window" tabindex="0" role="menuitem">Switch to New Window</li>

        <li class="menu-item" data-content="switch-tab-using-index" tabindex="0" role="menuitem">
          Switch Tab Using Index
        </li>
        <li class="menu-item" data-content="switch-window-by-index" tabindex="0" role="menuitem">
          Switch Window by Index
        </li>
        <li class="menu-item" data-content="switch-window-by-title" tabindex="0" role="menuitem">
          Switch Window by Title
        </li>
        <li class="menu-item" data-content="switch-window-by-url" tabindex="0" role="menuitem">
          Switch Window by URL
        </li>

        <li class="menu-item" data-content="get-current-window-index" tabindex="0" role="menuitem">
          Get Current Window Index
        </li>
        <li class="menu-item" data-content="get-window-count" tabindex="0" role="menuitem">
          Get Window Count
        </li>

        <li class="menu-item" data-content="refresh" tabindex="0" role="menuitem">Refresh</li>

        <!-- Frame Handling -->
        <li class="menu-subheading">Frame Handling</li>

        <li class="menu-item" data-content="switch-to-iframe" tabindex="0" role="menuitem">
          Switch to iFrame
        </li>
        <li class="menu-item" data-content="switch-to-iframe-by-index" tabindex="0" role="menuitem">
          Switch to iFrame by Index
        </li>
        <li class="menu-item" data-content="switch-to-iframe-by" tabindex="0" role="menuitem">
          Switch to iFrame by
        </li>
        <li class="menu-item" data-content="switch-to-default-content" tabindex="0" role="menuitem">
          Switch to Default Content
        </li>

        <!-- Session Handling -->
        <li class="menu-subheading">Session Handling</li>

        <li class="menu-item" data-content="open-secondary-session" tabindex="0" role="menuitem">
          Open Secondary Session
        </li>
        <li class="menu-item" data-content="close-secondary-session" tabindex="0" role="menuitem">
          Close Secondary Session
        </li>
        <li class="menu-item" data-content="switch-to-session-primary" tabindex="0" role="menuitem">
          Switch to Session Primary
        </li>
        <li class="menu-item" data-content="switch-to-session-secondary" tabindex="0" role="menuitem">
          Switch to Session Secondary
        </li>
      </ul>
    </div>
    <div class="sidebar-child-panel" id="interaction-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="interaction-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title" id="interaction-child-title">Interaction</span>
      </div>
      <ul class="menu" id="interaction-child-menu">
        <!-- Wait & Sync -->
        <li class="menu-heading">Wait &amp; Sync</li>

        <li class="menu-item" data-content="wait-for-element" tabindex="0" role="menuitem">
          Wait for Element
        </li>
        <li class="menu-item" data-content="wait-for-element-visibility" tabindex="0" role="menuitem">
          Wait for Element Visibility
        </li>
        <li class="menu-item" data-content="wait-for-element-clickability" tabindex="0" role="menuitem">
          Wait for Element Clickability
        </li>
        <li class="menu-item" data-content="pause" tabindex="0" role="menuitem">
          Pause
        </li>


        <!-- Mouse Actions -->
        <li class="menu-heading">Mouse Actions</li>

        <li class="menu-item" data-content="click" tabindex="0" role="menuitem">Click</li>
        <li class="menu-item" data-content="move-and-click" tabindex="0" role="menuitem">
          Move and Click
        </li>
        <li class="menu-item" data-content="double-click" tabindex="0" role="menuitem">
          Double Click
        </li>
        <li class="menu-item" data-content="right-click" tabindex="0" role="menuitem">
          Right Click
        </li>
        <li class="menu-item" data-content="mouse-over" tabindex="0" role="menuitem">
          Mouse Over
        </li>
        <li class="menu-item" data-content="move-to-element" tabindex="0" role="menuitem">
          Move to Element
        </li>

        <li class="menu-item" data-content="drag-and-drop" tabindex="0" role="menuitem">
          Drag and Drop
        </li>
        <li class="menu-item" data-content="drag-and-drop-to-offset" tabindex="0" role="menuitem">
          Drag and Drop to Offset
        </li>
        <li class="menu-item" data-content="drag-and-drop-to-coordinates" tabindex="0" role="menuitem">
          Drag and Drop with Coordinates
        </li>


        <!-- Keyboard & Input -->
        <li class="menu-heading">Keyboard &amp; Input</li>

        <li class="menu-item" data-content="enter-text" tabindex="0" role="menuitem">
          Enter Text
        </li>
        <li class="menu-item" data-content="move-click-and-enter-text" tabindex="0" role="menuitem">
          Move Click and Enter Text
        </li>
        <li class="menu-item" data-content="move-click-clear-and-enter-text" tabindex="0" role="menuitem">
          Move Click Clear and Enter Text
        </li>
        <li class="menu-item" data-content="press-key" tabindex="0" role="menuitem">
          Press Key
        </li>
        <li class="menu-item" data-content="submit-form" tabindex="0" role="menuitem">
          Submit Form
        </li>
        <li class="menu-item" data-content="copy" tabindex="0" role="menuitem">
          Copy
        </li>


        <!-- File & View -->
        <li class="menu-heading">File &amp; View</li>

        <li class="menu-item" data-content="upload-file" tabindex="0" role="menuitem">
          Upload File
        </li>
        <li class="menu-item" data-content="scroll-to-element" tabindex="0" role="menuitem">
          Scroll to Element
        </li>
        <!-- <li class="menu-item" data-content="take-screenshot" tabindex="0" role="menuitem">
          Take Screenshot
        </li> -->
      </ul>
    </div>
    <!-- Math & Vars Panel -->
    <div class="sidebar-child-panel" id="math-vars-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="math-vars-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Math & Vars</span>
      </div>

      <ul class="menu" id="math-vars-child-menu">
        <!-- Math & Variables Section -->
        <li class="menu-heading">Math & Variables</li>
        <li class="menu-item" data-content="add" tabindex="0" role="menuitem">Add</li>
        <li class="menu-item" data-content="subtract" tabindex="0" role="menuitem">Subtract</li>
        <li class="menu-item" data-content="multiplication" tabindex="0" role="menuitem">Multiplication</li>
        <li class="menu-item" data-content="division" tabindex="0" role="menuitem">Division</li>
        <li class="menu-item" data-content="array-size" tabindex="0" role="menuitem">Array Size</li>
        <li class="menu-item" data-content="random-value-generator" tabindex="0" role="menuitem">Random Value Generator</li>

        <!-- String Actions Section -->
        <li class="menu-heading">String Actions</li>
        <li class="menu-item" data-content="concat" tabindex="0" role="menuitem">Concat</li>
        <li class="menu-item" data-content="reverseString" tabindex="0" role="menuitem">Reverse String</li>
        <li class="menu-item" data-content="substringCount" tabindex="0" role="menuitem">Substring Count</li>
        <li class="menu-item" data-content="replace" tabindex="0" role="menuitem">Replace</li>
        <li class="menu-item" data-content="replaceAll" tabindex="0" role="menuitem">Replace All</li>
        <li class="menu-item" data-content="replaceRegex" tabindex="0" role="menuitem">Replace Regex</li>
        <li class="menu-item" data-content="trim" tabindex="0" role="menuitem">Trim</li>
        <li class="menu-item" data-content="trimLeft" tabindex="0" role="menuitem">Trim Left</li>
        <li class="menu-item" data-content="trimRight" tabindex="0" role="menuitem">Trim Right</li>
        <li class="menu-item" data-content="toUpper" tabindex="0" role="menuitem">To Upper</li>
        <li class="menu-item" data-content="toLower" tabindex="0" role="menuitem">To Lower</li>
        <li class="menu-item" data-content="indexOf" tabindex="0" role="menuitem">Index Of</li>
        <li class="menu-item" data-content="lastIndexOf" tabindex="0" role="menuitem">Last Index Of</li>
        <li class="menu-item" data-content="repeat" tabindex="0" role="menuitem">Repeat</li>
        <li class="menu-item" data-content="assert-text-contains" tabindex="0" role="menuitem">Assert Text Contains</li>
        <li class="menu-item" data-content="assert-texts" tabindex="0" role="menuitem">Assert Texts</li>
        <li class="menu-item" data-content="verify-text-contains" tabindex="0" role="menuitem">Verify Text Contains</li>
        <li class="menu-item" data-content="verify-texts" tabindex="0" role="menuitem">Verify Texts</li>
        <li class="menu-item" data-content="string-to-object" tabindex="0" role="menuitem">String To Object</li>
      </ul>
    </div>

    <!-- Logic Panel -->
    <div class="sidebar-child-panel" id="logic-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="logic-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Logic</span>
      </div>
      <ul class="menu" id="logic-child-menu">
        <li class="menu-heading">Logic &amp; Flow Control</li>

        <li class="menu-item" data-content="if-equals-to" tabindex="0" role="menuitem">
          If Equals To
        </li>
        <li class="menu-item" data-content="if-equals-ignore-case" tabindex="0" role="menuitem">
          If Equals Ignore Case
        </li>
        <li class="menu-item" data-content="if-greater-than" tabindex="0" role="menuitem">
          If Greater Than
        </li>
        <li class="menu-item" data-content="if-less-than" tabindex="0" role="menuitem">
          If Less Than
        </li>
        <li class="menu-item" data-content="if-element-present" tabindex="0" role="menuitem">
          If Element Present
        </li>

        <li class="menu-item" data-content="else" tabindex="0" role="menuitem">
          Else
        </li>
        <li class="menu-item" data-content="else-if-equals-to" tabindex="0" role="menuitem">
          Else If Equals To
        </li>
        <li class="menu-item" data-content="else-if-equals-ignore-case" tabindex="0" role="menuitem">
          Else If Equals Ignore Case
        </li>
        <li class="menu-item" data-content="else-if-element-present" tabindex="0" role="menuitem">
          Else If Element Present
        </li>

        <li class="menu-item" data-content="break" tabindex="0" role="menuitem">
          Break
        </li>
        <li class="menu-item" data-content="continue" tabindex="0" role="menuitem">
          Continue
        </li>
        <li class="menu-item" data-content="close-statement" tabindex="0" role="menuitem">
          Close Statement
        </li>

        <li class="menu-item" data-content="loop-count" tabindex="0" role="menuitem">
          Loop Count
        </li>
        <li class="menu-item" data-content="loop-equals" tabindex="0" role="menuitem">
          Loop Equals
        </li>
        <li class="menu-item" data-content="loop-less-than" tabindex="0" role="menuitem">
          Loop Less Than
        </li>

        <li class="menu-item" data-content="comment" tabindex="0" role="menuitem">
          Comment
        </li>
      </ul>
    </div>
    <!-- Verify Panel -->
    <div class="sidebar-child-panel" id="verify-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="verify-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Verify</span>
      </div>
      <ul class="menu" id="verify-child-menu">
        <li class="menu-heading">Verify &amp; Assert</li>

        <!-- Element Verification -->
        <li class="menu-item" data-content="verify-element-present" tabindex="0" role="menuitem">
          Verify Element Present
        </li>
        <li class="menu-item" data-content="verify-element-not-present" tabindex="0" role="menuitem">
          Verify Element Not Present
        </li>
        <li class="menu-item" data-content="verify-element-enabled" tabindex="0" role="menuitem">
          Verify Element Enabled
        </li>
        <li class="menu-item" data-content="verify-element-checked" tabindex="0" role="menuitem">
          Verify Element Checked
        </li>
        <li class="menu-item" data-content="verify-element-unchecked" tabindex="0" role="menuitem">
          Verify Element Unchecked
        </li>
        <li class="menu-item" data-content="verify-element-editable" tabindex="0" role="menuitem">
          Verify Element Editable
        </li>
        <li class="menu-item" data-content="verify-element-not-editable" tabindex="0" role="menuitem">
          Verify Element Not Editable
        </li>

        <!-- Selection Verification -->
        <li class="menu-item" data-content="verify-selected-option" tabindex="0" role="menuitem">
          Verify Selected Option
        </li>

        <!-- Text Verification -->
        <li class="menu-item" data-content="verify-text" tabindex="0" role="menuitem">
          Verify Text
        </li>
        <li class="menu-item" data-content="verify-text-contains" tabindex="0" role="menuitem">
          Verify Text Contains
        </li>
        <li class="menu-item" data-content="verify-text-ignore-case" tabindex="0" role="menuitem">
          Verify Text Ignore Case
        </li>

        <!-- Assertions -->
        <li class="menu-item" data-content="assert-text" tabindex="0" role="menuitem">
          Assert Text
        </li>
        <li class="menu-item" data-content="assert-value" tabindex="0" role="menuitem">
          Assert Value
        </li>
        <li class="menu-item" data-content="assert-element-checked" tabindex="0" role="menuitem">
          Assert element checked
        </li>
        <li class="menu-item" data-content="assert-element-unchecked" tabindex="0" role="menuitem">
          Assert element unchecked
        </li>
      </ul>
    </div>
    <!-- Get Data Panel -->
    <div class="sidebar-child-panel" id="getdata-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="getdata-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Get Data</span>
      </div>
      <ul class="menu" id="getdata-child-menu">
        <li class="menu-heading">Get Data</li>

        <li class="menu-item" data-content="get-text" tabindex="0" role="menuitem">
          Get Text
        </li>
        <li class="menu-item" data-content="get-value" tabindex="0" role="menuitem">
          Get Value
        </li>
        <li class="menu-item" data-content="get-positioned-word" tabindex="0" role="menuitem">
          Get Positioned Word
        </li>
        <li class="menu-item" data-content="get-text-search-count" tabindex="0" role="menuitem">
          Get Text Search Count
        </li>
        <li class="menu-item" data-content="get-link-from-element" tabindex="0" role="menuitem">
          Get Link From Element
        </li>
        <li class="menu-item" data-content="get-current-time" tabindex="0" role="menuitem">
          Get Current Time
        </li>
        <li class="menu-item" data-content="show-text-search-count" tabindex="0" role="menuitem">
          Show Text Search Count
        </li>
      </ul>
    </div>
    <!-- Alerts Panel -->
    <div class="sidebar-child-panel" id="alerts-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="alerts-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Alerts</span>
      </div>
      <ul class="menu" id="alerts-child-menu">
        <li class="menu-heading">Alerts</li>

        <li class="menu-item" data-content="accept-alert" tabindex="0" role="menuitem">
          Accept Alert
        </li>
        <li class="menu-item" data-content="dismiss-alert" tabindex="0" role="menuitem">
          Dismiss Alert
        </li>
        <li class="menu-item" data-content="type-alert-message" tabindex="0" role="menuitem">
          Type Alert Message
        </li>

        <li class="menu-item" data-content="verify-text-in-alert" tabindex="0" role="menuitem">
          Verify Text in Alert
        </li>
        <li class="menu-item" data-content="verify-text-contains-in-alert" tabindex="0" role="menuitem">
          Verify Text Contains in Alert
        </li>
        <li class="menu-item" data-content="assert-text-in-alert" tabindex="0" role="menuitem">
          Assert Text in Alert
        </li>
      </ul>
    </div>
    <!-- Dropdown Panel -->
    <div class="sidebar-child-panel" id="dropdown-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="dropdown-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Dropdown</span>
      </div>
      <ul class="menu" id="dropdown-child-menu">
        <li class="menu-heading">Dropdown</li>

        <li class="menu-item" data-content="dropdown-select" tabindex="0" role="menuitem">
          Dropdown Select
        </li>

        <li class="menu-item" data-content="select-box-by-visible-text" tabindex="0" role="menuitem">
          Select Box by Visible Text
        </li>
        <li class="menu-item" data-content="select-box-by-value" tabindex="0" role="menuitem">
          Select Box by Value
        </li>
        <li class="menu-item" data-content="select-box-by-index" tabindex="0" role="menuitem">
          Select Box by Index
        </li>
      </ul>
    </div>
    <!-- Utility Panel -->
    <div class="sidebar-child-panel" id="utility-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="utility-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">Utility</span>
      </div>
      <ul class="menu" id="utility-child-menu">
        <li class="menu-heading">Utility</li>
        <li class="menu-item" data-content="compare-image-snippet" tabindex="0" role="menuitem">
          Compare Image Snippet
        </li>
        <li class="menu-item" data-content="verify-image-snippet" tabindex="0" role="menuitem">
          Verify Image Snippet
        </li>
        <li class="menu-item" data-content="assert-image-snippet" tabindex="0" role="menuitem">
          Assert Image Snippet
        </li>
        <li class="menu-item" data-content="js-snippet" tabindex="0" role="menuitem">
          JS Snippet
        </li>
      </ul>
    </div>
    <!-- API Panel -->
    <div class="sidebar-child-panel" id="api-child-panel">
      <div class="sidebar-child-header">
        <button class="sidebar-child-back" id="api-child-back" aria-label="Back">&#8592;</button>
        <span class="sidebar-child-title">API</span>
      </div>
      <ul class="menu" id="api-child-menu">
        <li class="menu-item" data-content="get-api" tabindex="0" role="menuitem">GET api</li>
        <li class="menu-item" data-content="post-api" tabindex="0" role="menuitem">POST api</li>
        <li class="menu-item" data-content="put-api" tabindex="0" role="menuitem">PUT api</li>
        <li class="menu-item" data-content="patch-api" tabindex="0" role="menuitem">PATCH api</li>
        <li class="menu-item" data-content="delete-api" tabindex="0" role="menuitem">DELETE api</li>
        <li class="menu-item" data-content="head-api" tabindex="0" role="menuitem">HEAD api</li>
        <li class="menu-item" data-content="options-api" tabindex="0" role="menuitem">OPTIONS api</li>
      </ul>
    </div>
  </nav>
  <main class="main-content" id="main-content">
    <!-- Content will be dynamically loaded here when menu items are clicked -->
  </main>
</div>